<template>
    <div class="invite-content" @mouseover="hover = true" @mouseleave="hover = false">
        <div class="invite-left" v-text="name"></div>

        <div class="invite-right d-flex flex-column justify-content-center">
            <button v-if="hover && editable" type="button" class="btn-text" @click="showInviteModal">Edit</button>
            <div v-else v-text="phone"></div>
        </div>
    </div>
</template>

<script>
    import store from "../../../store";
    import invite from "../../../store/modules/invite";

    export default {
        name: "SuccessInvite",

        props: {
            'index' : {
                type: Number,
                required: true
            },
            'editable' : {
                type: Boolean,
                required: false,
                default: true,
            }
        },

        data() {
            return {
                hover: false
            }
        },

        computed : {
            invite() {
                return this.$store.getters['success/getInvite'](this.index);
            },

            name() {
                return this.invite ? this.invite.first_name + ' ' + this.invite.last_name : '';
            },

            phone() {
                return this.invite ? this.invite.phone_number.raw : '';
            }
        },

        methods : {
            showInviteModal() {
                store.commit('success/showInviteModal', this.$props.index);
            },
        },

    }
</script>
